import React, { Component } from 'react';
import axios from "axios";
import Constants from "../App/Variables/Constant";
import {Link,Navigate } from "react-router-dom";
import init from "../helpers/WindowToken";
import {
    Button,
    Container,
    Grid,
    Snackbar,
    TextField,
    Typography
}from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';



export default class UpdateSubscription extends Component {
  state = {
    loading: false,
    subscriptionId:"",
    title: "",
    no_of_seller:"",
    validity:"",
    price:"",
    notification: false,
    testimonialId: "",
    message: "",
    redirect: false,
  textChange:false,
  error:false
  };
  componentDidMount() {
    this.getSubscription();
 
   }
   getSubscription=()=>{
    let id = window.location.pathname.split("/")[3];
    this.setState({
      subscriptionId: id,
    });

    if (init() === "success") {
      let auth = localStorage.getItem("accessToken");
      axios
        .get(Constants.getUrls.getSubscription + id, {
          headers: { Authorization: `Bearer ${auth}` },
        })
        .then((resp) => {
          // console.log("this");
          // console.log(resp);
         
          this.setState({
            title:resp.data.subscription.title,
            no_of_seller:resp.data.subscription.no_of_seller,
            validity:resp.data.subscription.validity,
            price:resp.data.subscription.price,

        
          }
          // ,()=>{
          //   console.log(this.state.image)
          // }
          );
        });
    }
  }
  handleChange=(e)=>{
    if(e.target.name==="title"){
      this.setState({
        error:false
      })
    }
    this.setState({
      [e.target.name]:e.target.value,
      textChange:true
    })
  }
 
  handleSubmit = (e) => {
    e.preventDefault();

  

    this.setState({ loading: true });

    if (init() === "success") {
      let auth = localStorage.getItem("accessToken");
      // if (
      //   this.state.image === null ||
      //   this.state.image === "" ||
      //   this.state.title === null ||
      //   this.state.title === "" ||
      //   this.state.description === null ||
      //   this.state.description === ""
      // ) {
      //   this.setState({
      //     notification: true,
      //     message: "Check your input.It cant be null or empty",
      //     loading: false,
      //   });
      //   setTimeout(
      //     () =>
      //       this.setState({ notifcation: false, message: "", loading: false }),
      //     2000
      //   );
      //   setTimeout(() => this.getTestimonial(), 3000);
      // } else {
        
        let fd={
          title:this.state.title,
          no_of_seller:this.state.no_of_seller,
          validity:this.state.validity,
          price:this.state.price,    
        }
      
// if(this.state.textChange===false){
//   this.setState({notification:true,
//   message:"nothing to change here"})
//   setTimeout(() => {
//     this.setState({notification:false,
//       loading:false,
//       redirect:true
//     })
//   }, 2000);
// } else {
  // console.log(Constants.putUrls.updateSubscription + this.state.subscriptionId);
        axios
          .put(Constants.putUrls.updateSubscription + this.state.subscriptionId, fd, {
            headers: {
              // "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${auth}`,
            },
          })
          .then((resp) => {
            // axios.post("http://localhost:8081/createStocks", stockLoad).then((resp) => {
              // console.log(this.state.image);
            this.setState({
              loading: false,
              notification: true,
              message: resp.data.message,
              
            });
            if (resp.data.message === undefined || resp.data.message === null) {
              // console.log(resp);
              if(resp.data.errors.msg){
              this.setState({
                message: resp.data.errors.msg,
              });}
              else {
                this.setState({
                  message:"unknown error"
                })
              }
            }
            if(resp.data.message===`title already exist with the name ${this.state.title}`){
              this.setState({
                error:true
              })
            }
            setTimeout(() => {
              this.setState({
                // title: "",
                // no_of_seller:"",
                // validity:"",
                // price:"",
                message:"",
                notification: false,
              });
              // fd.delete("title", this.state.title);
              // fd.delete("description", this.state.description);
              // fd.delete("image", this.state.image);
            }, 2000);
            if(resp.data.message==="Updated Successfully"){
            setTimeout(() => {
              this.setState({
                redirect:true
              })
            }, 3000);
       }
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              notification:true,
              message:"some error occured check your console"
            })
            setTimeout(() => {
              this.setState(
                {
                  // title: "",
                  // no_of_seller:"",
                  // validity:"",
                  // price:"",
                 notification:false,
                 message:"",
                 loading: false
                }
               
              );
             
              
            }, 2000);
            
            // setTimeout(() => {
            //   this.getSubscription();
            // }, 3000);
          });
        // }
      // }
    }
  };
  render() {
    return (
      <Container maxWidth="xl">
       { 
   this.state.redirect && <Navigate to='/subscription' replace={true}/>
}  
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="h6"> Update Subscription </Typography>
          </Grid>
        </Grid>
        {this.state.notification ? (
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={true}
            autoHideDuration={5000}
            color="green"
            message={this.state.message}
          ></Snackbar>
        ) : null}
        <div
          style={{
            background: "#5b5757",
            padding: "20px",
            borderRadius: "10px",
            // color: rgba(0, 0, 0, 0.87);
            width: "100%",
            border: "0",
            display: "flex",
            position: "relative",
            fontSize: ".875rem",
            minWidth: "0",
            wordWrap: " break-word",
            /* background: #FFF; */
            boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
            marginTop: "30px",
            borderRadius: "6px",
            marginBottom: "30px",
            flexDirection: "column",
            textAlign: "left",
          }}
        >
          <div
            style={{
              background:
                "linear-gradient(60deg, rgb(128 115 115), rgb(255 250 250)) rgb(153, 153, 153))",
              boxShadow:
                " rgb(0 0 0 / 14%) 0px 4px 20px 0px, rgb(128 120 120 1/ 40%) 0px 7px 10px -5px",
              float: "left",
              padding: "15px",
              marginTop: "-43px",
              marginRight: "15px",
              borderRadius: "3px",
              backgroundColor: "#999",
              width: "6%",
              height: "60px",
              marginBottom: "25px",
              textAlign: "center",
            }}
          >
            <EditIcon />
          </div>
          <form onSubmit={this.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item sm={4}>
                <TextField
                  name="title"
                  error={this.state.error}
                id={this.state.error?"outlined-error":"outlined-basic"}
                label={this.state.error?"Error":"Title"}
                  size="medium"
                  variant="outlined"
                  required={true}
                  type="text"
                  onChange={this.handleChange}
                  style={{ width: "100%" }}
                  value={this.state.title}
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  name="no_of_seller"
                  id="outlined-basic"
                  label="No. of Seller"
                  size="medium"
                  variant="outlined"
                  required={true}
                  type="number"
                  InputProps={{
        inputProps: { 
            min:0
        }
    }}
                  onChange={this.handleChange}
                  style={{ width: "100%" }}
                  value={this.state.no_of_seller}
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  name="validity"
                  id="outlined-basic"
                  label="Validity"
                  size="medium"
                  variant="outlined"
                  required={true}
                  type="number"
                  InputProps={{
        inputProps: { 
            min:0
        }
    }}
                  onChange={this.handleChange}
                  style={{ width: "100%" }}
                  value={this.state.validity}
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  name="price"
                  id="outlined-basic"
                  label="Price"
                  size="medium"
                  variant="outlined"
                  required={true}
                  type="number"
                  InputProps={{
        inputProps: { 
            min:0
        }
    }}
                  onChange={this.handleChange}
                  style={{ width: "100%" }}
                  value={this.state.price}
                />
              </Grid>
            </Grid>
          
                
          
                <br />
            <Button
              variant="contained"
              type="submit"
              size="medium"
              color="primary"
              style={{
                marginRight: "20px",

                marginTop: "35px",
              }}
            >
              {this.state.loading ? "Updating.." : "Update "}
            </Button>
            <Link
              to={{
                pathname: "/subscription",
              }}
              style={{ textDecoration: "none" }}
            >
              <Button
                variant="contained"
                type="submit"
                color="secondary"
                style={{ marginRight: "20px", marginTop: "35px" }}
              >
                Cancel
              </Button>
            </Link>
          </form>
        </div>
      </Container>
    )
  }
}
